export const FORCE_POLLING_INTERVAL_MS = 15000;
// Heartbeat interval to detect sleep/wake
export const HEARTBEAT_INTERVAL_MS = 5000;
// If the heartbeat is delayed by more than this threshold, consider it a wake from sleep
export const SLEEP_DETECTION_THRESHOLD_MS = 30000;
// Delay to let network stabilize after wake/reconnect
export const NETWORK_STABILIZATION_DELAY_MS = 3000;

